import { Vector3 } from "three";
import { ICharacterState } from "./ICharacterState";
import { Character } from "../Character";
import { CharacterAnimationController, CharacterAnimationState } from "../animations/CharacterAnimationController";
import { CharacterStates } from "./CharacterStates";
import { AudioController, Sfx } from "../../../AudioController";

export class HitState implements ICharacterState {
    private nextState: CharacterStates;
    constructor(
        private readonly character: Character,
        private readonly animationController: CharacterAnimationController,
        private readonly audioController: AudioController
    ) { }

    public enter(): void {
        if (this.character.alive) {
            this.nextState = CharacterStates.HIT;
            this.animationController.transitToState(CharacterAnimationState.Hit);
            this.animationController.onClipEnd.add(this.handleClipEnd, this);
        } else {
            this.nextState = CharacterStates.DIE;
        }
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
        this.character.resetHitTimeout();
        this.character.resetDamageLimit();
    }

    public process(_dt: number): CharacterStates {
        return this.nextState;
    }

    public onInput(_value: Vector3): void { }

    public onTakeDamage(amount: number): void {
        this.audioController.playSfx(Sfx.Hit);
        this.character.health.setValue(Math.max(this.character.health.value - amount, 0));
        if (!this.character.alive) {
            this.animationController.onClipEnd.remove(this.handleClipEnd, this);
            this.nextState = CharacterStates.DIE;
        }
    }

    private handleClipEnd(_state: CharacterAnimationState): void {
        this.nextState = CharacterStates.IDLE;
    }
}
